<template>
  <highlight-card
    :button="{ label: texts.photosCta }"
    :heading="slideshow.lifeTitle"
    :status="status"
    :text="sprintf(common.timelineDescription, genitive)"
    @action="addPhoto"
  >
    <template #media>
      <film-poster
        :image="image"
        :text="slideshow.playLife"
        @play="openViewer({ kind: 'life', source: 'current_events' })"
      />
    </template>
  </highlight-card>
</template>

<script lang="ts" setup>
  import {
    lifeStoryPoster,
    openViewer,
    quickContent,
    slideshowTexts,
  } from "Plugins/obituary/javascript/composables/useSlideshow";
  import { MEDIA_INITIAL } from "Plugins/obituary/javascript/createCommentStepsHelper";
  import {
    commonTexts,
    highlightTexts,
  } from "Plugins/obituary/javascript/highlights/texts";
  import { lifeMedia } from "Plugins/obituary/javascript/slideshow/playlist";
  import { sprintf } from "sprintf-js";
  import { useStore } from "vuex";
  import HighlightCard from "../HighlightCard.vue";
  import FilmPoster from "./FilmPoster.vue";

  const store = useStore();
  const texts = highlightTexts();
  const common = commonTexts();
  const slideshow = slideshowTexts();
  const content = quickContent();
  const image = lifeStoryPoster(content);
  const genitive = content?.deceased.genitive ?? "";

  // "46 bilder · 1940-talet – 2020-talet": the life story's photos, oldest first.
  const photos = content
    ? lifeMedia(content).filter((m) => m.type === "image")
    : [];
  const decade = (year: number | null | undefined) =>
    sprintf(slideshow.decade || "%s", Math.floor((year ?? 0) / 10) * 10);
  const status = photos.length
    ? [
        sprintf(slideshow.photoCount || "%d", photos.length),
        `${decade(photos[0].year)} – ${decade(photos.at(-1)?.year)}`,
      ].join(" · ")
    : undefined;

  function addPhoto() {
    store.dispatch("createComment/toggleModal", MEDIA_INITIAL);
  }
</script>
